import { render, staticRenderFns } from "./FilaMensagens.vue?vue&type=template&id=20f368c8"
import script from "./FilaMensagens.vue?vue&type=script&lang=ts"
export * from "./FilaMensagens.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports